'use client';
import { jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useMemo } from 'react';
import { removeCoreProps } from '../core/core.utils.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { SwanListboxContextProvider } from './listbox.context.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';
import { CollectionContextProvider } from '../../contexts/internal/collection/collection.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { className } from '../../../core/utilities/classnames.utils.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let useSelectionProps = ({ selectionMode: e = 'single', selectedKeys: n, onSelectionChange: i, value: s, onChange: c })=>{
    let l = useRef(false);
    'single' !== e && (c || s) && !l.current && (console.warn('Listbox - Do not use "onChange" or "value" props with multiple selection mode. Only one item will be selected'), l.current = true);
    let p = useCallback((t)=>{
        i && i(t), c && 'single' === e && 'all' !== t && c([
            ...t
        ][0]);
    }, [
        c,
        i,
        e
    ]);
    return useMemo(()=>({
            selectionMode: e,
            selectedKeys: s ? new Set([
                s
            ]) : n,
            onSelectionChange: p
        }), [
        e,
        s,
        n,
        p
    ]);
};
const Listbox = renderWithRef('Listbox', null, (t, r)=>{
    useDeprecatedProps('Listbox', t, [
        {
            propName: 'size',
            instructions: 'Sizing is now handled automatically by standardMode/compactMode.'
        }
    ]), useComponentStylesLoaded('Listbox', [
        SWAN_STYLE_KEY_MAP.listbox,
        SWAN_STYLE_KEY_MAP.popover
    ]);
    let { children: o, disabled: i = false, fullWidth: d = false, size: m = 'standard', skin: f = 'standard', selectionMode: y, selectedKeys: O, disabledKeys: _, onSelectionChange: j, onChange: h, value: w, items: g, maxHeight: x } = t, P = _object_without_properties(t, [
        "children",
        "disabled",
        "fullWidth",
        "size",
        "skin",
        "selectionMode",
        "selectedKeys",
        "disabledKeys",
        "onSelectionChange",
        "onChange",
        "value",
        "items",
        "maxHeight"
    ]), v = useSelectionProps({
        selectionMode: y,
        selectedKeys: O,
        onSelectionChange: j,
        value: w,
        onChange: h
    }), S = className('swan-listbox', {
        'swan-listbox-mini': 'mini' === m,
        'swan-listbox-full-width': d
    }, ...processStyleProps(P), t.className), k = _object_spread_props(_object_spread({}, removeCoreProps(P)), {
        className: S
    });
    return jsx("div", _object_spread_props(_object_spread({}, k), {
        ref: r,
        children: jsx(CollectionContextProvider, {
            items: g,
            disabledKeys: _,
            children: jsx(SwanListboxContextProvider, {
                fullWidth: d,
                skin: f || 'standard',
                disabled: null != i && i,
                selectionProps: v,
                maxHeight: x,
                children: o
            })
        })
    }));
});

export { Listbox };
